'use client'

import { useEffect, useRef } from 'react'
import { AnalyticsPlatforms, getAnalyticsInstance } from '../core/createAnalyticsProviders'
import { GA4 } from '../core/GA4'

export const useGa4ClientId = () => {
  const store = useRef<string | undefined>(undefined)

  /**
   * 取得 GA4 client id 並存到 ref 中，結帳時帶入 headers
   * 在 useEffect 先取得防止 processPayment 時需要等待以及避免錯誤的發生
   */
  useEffect(() => {
    const setGaClientId = async () => {
      try {
        const gaInstance = getAnalyticsInstance(AnalyticsPlatforms.GA4)
        const gaClientId = await (gaInstance instanceof GA4 ? gaInstance.getGtagValue<string>('client_id') : undefined)
        store.current = gaClientId
      }
      catch (error) {
        console.error('[gaClientId] get ga client id failed', error)
      }
    }
    setGaClientId()
  }, [])

  return store
}
